import React, { useRef, useState } from 'react';

// Player della registrazione 456 (riascolto dalla cronologia): finestra in stile app,
// con onda animata durante l'ascolto. Nessuna emoji, solo SVG.
export default function RegistrazionePlayer({ src, numero, onClose }) {
  const audioRef = useRef(null);
  const [playing, setPlaying] = useState(false);
  const [err, setErr] = useState(false);

  const toggle = () => {
    const a = audioRef.current;
    if (!a) return;
    if (a.paused) a.play().catch(() => setErr(true)); else a.pause();
  };

  return (
    <div className="scrim" onClick={onClose}>
      <div className="modal num" style={{ textAlign: 'center', width: 'min(360px,92vw)' }} onClick={e => e.stopPropagation()}>
        <div className="ic" style={{ width: 52, height: 52, margin: '0 auto 10px' }}>
          {/* cuffie */}
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.1" strokeLinecap="round" strokeLinejoin="round">
            <path d="M4 14v-2a8 8 0 0 1 16 0v2" />
            <rect x="2.5" y="14" width="4.5" height="6.5" rx="2" />
            <rect x="17" y="14" width="4.5" height="6.5" rx="2" />
          </svg>
        </div>
        <div style={{ fontWeight: 800, fontSize: 16, color: 'var(--ink)' }}>Registrazione 456</div>
        <div style={{ fontSize: 13, color: 'var(--muted)', marginBottom: 12 }}>{numero || ''}</div>

        <div className={`regwave${playing ? ' on' : ''}`} onClick={toggle} title={playing ? 'Pausa' : 'Ascolta'}>
          {Array.from({ length: 11 }).map((_, i) => <i key={i} style={{ animationDelay: `${(i % 6) * 0.09}s` }} />)}
        </div>

        <button className="btn" onClick={toggle} style={{ marginTop: 14, width: '100%' }}>
          {playing ? (
            <><svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><rect x="6" y="5" width="4" height="14" rx="1" /><rect x="14" y="5" width="4" height="14" rx="1" /></svg> Pausa</>
          ) : (
            <><svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M7 5v14l12-7z" /></svg> Ascolta</>
          )}
        </button>
        {err && <div className="foot" style={{ color: '#ef4444', marginTop: 8 }}>Registrazione non più disponibile.</div>}

        <audio ref={audioRef} src={src} preload="none"
          onPlay={() => setPlaying(true)} onPause={() => setPlaying(false)}
          onEnded={() => setPlaying(false)} onError={() => setErr(true)} />
      </div>
    </div>
  );
}
